import { render, staticRenderFns } from "./NotificationCreate.vue?vue&type=template&id=8a6fadc8&"
import script from "./NotificationCreate.vue?vue&type=script&lang=ts&"
export * from "./NotificationCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports